import React, { useCallback, useEffect, useRef, useState } from "react";
import Button from "../../framework/Button";
import Modal from "../../framework/modal/Modal";
import TextInput from "../../framework/TextInput";
import { displayToast } from "../../framework/toast/toastUtils";
import { getRole } from "../../services/roles-service";
import c from "./EditRole.module.css";
const EditRole = ({
  id,
  showModal = false,
  onClick = () => {},
  onEscape = () => {},
}) => {
  const new_role_ref = useRef();
  const [role, setRole] = useState(null);
  const clickHandler = useCallback(
    (e) => {
      if (!role?.role)
        return displayToast({
          type: "error",
          title: "Please enter a valid role name.",
        });
      onClick(e, role);
    },
    [onClick, role]
  );
  const changeHandler = useCallback(
    (e) => {
      if (role) {
        setRole((prev) => {
          prev["role"] = e.target.value;
          return prev;
        });
      } else {
        setRole({
          role: e.target.value,
          privileges: [],
          deleted: false,
        });
      }
    },
    [role]
  );
  useEffect(() => {
    if (showModal && id) {
      getRole(`id=${id}`).then((r) => {
        if (r.status === "success") setRole(r.result);
        new_role_ref.current.value = r.result.role;
      });
    }
  }, [showModal, id]);
  useEffect(() => {
    if (showModal)
      setTimeout(() => {
        new_role_ref.current?.focus();
      }, 100);
  });
  return (
    <Modal
      header="New Role"
      height="200px"
      open={showModal}
      onEscape={onEscape}
      onClose={onEscape}
    >
      <div className={c["add-role-modal"]}>
        <TextInput
          label="Role Name"
          onChange={changeHandler}
          ref={new_role_ref}
        />
        <div className={c["add-role-ctas"]}>
          <Button
            label={role?._id ? "Update Role" : "Create Role"}
            onClick={clickHandler}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditRole;
